const DateFormat = ({ text }: { text: any }) => {
  const date = new Date(text);
  if (isNaN(date.getTime())) {
    return null;
  }
  let utcTime = new Date(text);
  if (!text.includes('Z')) utcTime = new Date(text + 'Z');
  const nepalTimeFormat = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kathmandu',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour12: true,
  });
  const localTime = nepalTimeFormat.format(utcTime);
  return <>{localTime}</>;
};

export default DateFormat;
